import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-order-type-picker-dialog',
  templateUrl: './order-type-picker-dialog.component.html',
  styleUrls: ['./order-type-picker-dialog.component.scss']
})
export class OrderTypePickerDialogComponent implements OnInit 
{

  orderData:any;

  constructor
  (
    private currentinfoservice:CurrentInfoService, 
    public dialogRef: MatDialogRef<OrderTypePickerDialogComponent>, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService
    ) { }

  ngOnInit(): void 
  {
    this.initializeTypes();
  }

  back()
  {
    this.navigationservice.back();
  }

  initializeTypes()
  {
    this.orderData = this.currentinfoservice.getOrderTypes();
  }

  setOrderType(type:number)
  {
    this.currentorderservice.clear();

    this.currentorderservice.setOrderType(type);

    this.dialogRef.close('done');
  }
}
